import React from 'react';
import ColorDropdown from 'components/pure/utils/ColorDropdown';
import SelectField from 'components/pure/utils/form/SelectField';
import TrashIcon from 'components/pure/utils/icon/TrashIcon';

export default class CallColorsRow extends React.Component {
  render() {
    const {dropdownValues, selectedValues, selectedValue} = this.props;

    // remove all the items that have already been selected unless it is this row's selected value
    const filteredValues = dropdownValues.filter(
      item => item.value === selectedValue || !selectedValues.contains(item.value),
      dropdownValues
    );

    return (
      <div className="color-row">
        <ColorDropdown
          selectedColor={this.props.selectedColor}
          numColors={8}
          onChange={this.props.colorChange}
        />
        <SelectField
          name="searchField"
          hideResetButton={true}
          tether={true}
          className=""
          value={this.props.selectedValue}
          options={filteredValues}
          onChange={this.props.valueChange}
        />
        {this.props.selectedValue ? null : <div className="error">*Please select a value</div>}
        <div className="remove-row" onClick={this.props.removeRow}>
          <TrashIcon />
        </div>
      </div>
    );
  }
}
